var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiosk-welcome",staticStyle:{"flex-direction":"column"}},[_c('div',[_c('div',{staticClass:"h3 mb-5"},[_c('div',{staticClass:"mb-4"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$tc('welcome')))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('router-link',{attrs:{"to":"select-option"},nativeOn:{"click":function($event){return _vm.changeLanguage({
            flag: 'us',
            language: 'en',
            lang: 'eng',
            lang_id: 1,
            title: 'English'
        },
        { brij_lang_id: 1, iso_2: 'en' }
        )}}},[_c('div',{staticClass:"btn-round"},[_c('div',{staticClass:"btn-content"},[_c('div',[_vm._v("ENGLISH")])])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"select-option"},nativeOn:{"click":function($event){return _vm.changeLanguage({
            flag: 'ar',
            language: 'ar',
            lang: 'ar',
            lang_id: 3,
            title: 'عربى'
        },
        { brij_lang_id: 3, iso_2: 'ar' }
        )}}},[_c('div',{staticClass:"btn-round"},[_c('div',{staticClass:"btn-content"},[_c('div',[_vm._v("عربى")])])])])],1)]),_vm._v(" "),_c('aside',{staticClass:"hidden-block",attrs:{"id":"hidden-aside"},on:{"dblclick":_vm.gotoSettingLogin}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n        PLEASE SELECT YOUR\n        "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("PREFERRED LANGUAGE")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03e901ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/kiosk/index.vue
// module id = 1243
// module chunks = 173